import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'
import { AMQueryParams } from 'src/v2/types/url'

type LegacyParams = {
  lid?: string
  pid?: string
}
// Changes lid to id.am-loc & pid to id.google
export const LegacyParamsRewrite = () => {
  const router = useRouter()

  const rewriteURLWithUpdatedParams = useCallback(async () => {
    const query = router.query as LegacyParams
    const rewrittenQuery: AMQueryParams = {}
    if (query.lid) {
      rewrittenQuery['id.am-loc'] = query.lid
    }
    if (query.pid) {
      rewrittenQuery['id.google'] = query.pid
    }

    // Don't do anything if we found nothing to rewrite
    if (!Object.keys(rewrittenQuery).length) {
      return
    }

    const path = router.asPath.split('?')[0]
    await router.push({
      pathname: path,
      query: rewrittenQuery,
    })
  }, [router.query])

  useEffect(() => {
    void rewriteURLWithUpdatedParams()
  }, [rewriteURLWithUpdatedParams])

  return null
}
